module.exports = __webpack_public_path__ + "img/lixian.3748a93e.png";